const styles = {
  paper: {
    backgroundColor: '#f4f4f4',
    flex: 1,
  },
  paperDoc: {
    backgroundColor: '#f4f4f4',
    padding: 1,
    flex: 1,
  },
  btnBase: {
    width: '100%',
    padding: 1,
    borderRadius: '4px',
  },
  checkBox: {
    padding: 0,
    mx: 1,
  },
};

export default styles;
